import getScrollAccessor from './getScrollAccessor';
/**
 * Gets or sets the scroll left position of a given element.
 * 
 * @param node the element
 * @param val the position to set
 */

export default getScrollAccessor('pageXOffset');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-big-calendar/node_modules/dom-helpers/esm/scrollLeft.js
// module id = 240
// module chunks = 0